import { Controller } from 'libraries/front-end-core/core/Router'
import getUrl from 'libraries/front-end-core/core/url'
import { ACCESS_DENIED } from 'constants/controllers'
import Main from './Main'

export default new Controller({
  name: ACCESS_DENIED,
  route: 'access-denied',
  controller (Router, { query: { client = '' } }, render) {
    const pageId = getUrl(ACCESS_DENIED)
    render(
      { Main },
      { client },
      { pageId, className: 'access-denied' }
    )
    return pageId
  }
})
